var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout, Auth } from "~/core/decorator";
import NumberRange from "~/components/common/number-range.vue";
import SelectEntrusted from "~/components/outsource-manage/case-allot/select-entrusted.vue";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { OutsourceLawsuitStayService } from "~/services/domain-service/outsource-lawsuit-manage.service";
import { MENU_CHANNEL } from "~/config/enum.config";
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
var LawsuitManageIndex = /** @class */ (function (_super) {
    __extends(LawsuitManageIndex, _super);
    function LawsuitManageIndex() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dialog = {
            selectEntrusted: false
        };
        _this.queryModel = {
            caseNumber: "",
            personalName: "",
            mobileNo: "",
            idCard: "",
            departmentType: "",
            outAmount: {
                max: "",
                min: ""
            },
            caseMoney: { min: "", max: "" },
            overduePeriod: "",
            overdueDays: {
                max: "",
                min: ""
            },
            turnSource: "",
            productCategory: "",
            creatTime: [],
            lawNumber: "",
            labelName: ""
        };
        _this.stayDataList = []; //数据列表
        _this.selectionList = []; //选中数据
        _this.temp = {}; //选中数据
        _this.tempData = [];
        return _this;
    }
    LawsuitManageIndex.prototype.mounted = function () {
        this.refreshData();
    };
    LawsuitManageIndex.prototype.selectCase = function () {
        if (this.selectionList.length === 0) {
            this.$message.info("请选择需要分案的案件");
            return;
        }
        this.dialog.selectEntrusted = true;
    };
    LawsuitManageIndex.prototype.refreshData = function () {
        var _this = this;
        //默认加载列表
        this.outsourceLawsuitStayService
            .searchPendingList(this.queryModel, this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.stayDataList = data;
            _this.selectionList = [];
        });
    };
    /**
     * 进入查看执行页
     */
    LawsuitManageIndex.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.caseId, {
            menuChannel: MENU_CHANNEL.Outsource_lawsuit_await,
            hiddenCaseList: true,
            hiddenAction: true
        });
    };
    // 重置numberRange
    LawsuitManageIndex.prototype.follFeedback = function () {
        this.queryModel.outAmount = { min: "", max: "" };
        this.queryModel.overdueDays = { min: "", max: "" };
        this.queryModel.caseMoney = { min: "", max: "" };
    };
    Object.defineProperty(LawsuitManageIndex.prototype, "selectedCaseIds", {
        get: function () {
            return this.selectionList.map(function (v) { return v.id; });
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Dependencies(OutsourceLawsuitStayService)
    ], LawsuitManageIndex.prototype, "outsourceLawsuitStayService", void 0);
    __decorate([
        Dependencies(PageService)
    ], LawsuitManageIndex.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], LawsuitManageIndex.prototype, "sortService", void 0);
    LawsuitManageIndex = __decorate([
        Auth(1010),
        Layout("workspace"),
        Component({
            components: {
                GetLabelName: GetLabelName,
                NumberRange: NumberRange,
                SelectEntrusted: SelectEntrusted
            }
        })
    ], LawsuitManageIndex);
    return LawsuitManageIndex;
}(Vue));
export default LawsuitManageIndex;
